import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isAuthenticated, getUserInfo, clearTokens } from '../utils/auth';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthentication = () => {
      // Check if user is authenticated
      if (!isAuthenticated()) {
        // Not authenticated, redirect to login
        console.log('User not authenticated, redirecting to login');
        clearTokens(); // Clear any invalid tokens
        navigate('/');
        return;
      }

      // Get user info if authenticated
      getUserInfo();
      setIsLoading(false);
    };

    checkAuthentication();
  }, [navigate]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // Render children if authenticated
  return (
    <div>
      {children}
    </div>
  );
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;